import packageJson from '../../../package.json';
import type {FeedbackContext} from "./types";

export const FEEDBACK_CONSENT_VERSION = 'raw-data-share-v1';

export const getFeedbackAppVersion = () => packageJson.version || 'unknown';

export const getFeedbackBrowserLabel = () => {
    if (typeof navigator === 'undefined') {
        return 'unknown';
    }

    return navigator.userAgent || 'unknown';
};

export const getFeedbackDeviceLabel = () => {
    if (typeof navigator === 'undefined') {
        return 'unknown';
    }

    const userAgentData = (navigator as Navigator & { userAgentData?: { mobile?: boolean } }).userAgentData;
    if (userAgentData?.mobile) {
        return 'mobile';
    }

    return window.matchMedia?.('(pointer: coarse)')?.matches ? 'mobile' : 'desktop';
};

export const estimateJsonBytes = (value: unknown) => {
    const encoded = JSON.stringify(value);
    return encoded ? new Blob([encoded]).size : 0;
};

export const getFeedbackContextFromPath = (pathname: string): Partial<FeedbackContext> => {
    if (pathname.startsWith('/hotspot-explorer/hotspot/')) {
        return {
            entityType: 'hotspot',
            entityId: decodeURIComponent(pathname.split('/hotspot-explorer/hotspot/')[1] ?? '')
        };
    }

    if (pathname.startsWith('/family-explorer/family/') && pathname.includes('/species/')) {
        const speciesCode = pathname.split('/species/')[1]?.split('/')[0] ?? '';
        return {
            entityType: 'species',
            entityId: decodeURIComponent(speciesCode)
        };
    }

    if (pathname.startsWith('/family-explorer/family/')) {
        const familySlug = pathname.split('/family/')[1]?.split('/')[0] ?? '';
        return {
            entityType: 'family',
            entityId: decodeURIComponent(familySlug)
        };
    }

    return {};
};
